let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d3Mqz")).then(() => parcelRequire('ezyVI'));